import React from "react";
import { Link } from "react-router-dom";
import "./Futures.css";
const Futures = () => {
  return (
    <>
      <div className="container">
        <div className="d-grid gap-2 pt-3">
          <Link className="btn btn-primary" to="/user/futures/news">
            Platform Details
          </Link>
        </div>
      </div>

      <section className="futures-section">
        <div className="container">
          <div className="container mb-3">
            <div className="row">
              <div className="d-flex justify-content-center">
                <div className="cardx">
                  <div>
                    <p className="mb-0 small text-info">Current Boost</p>
                  </div>
                  <div className="text-light">
                    <p>Order Available</p>
                  </div>
                </div>
              </div>
              <div className="d-none text-center">
                <div className="cardx">
                  <p className="mb-0 small text-success">Team profit</p>
                  <div className="row justify-content-center">
                    <div className="col-0">
                      <img
                        src="https://onlinebuzzmall.com/assets/images/logoIcon/logo.png"
                        alt=""
                        width="20px"
                        height="20px"
                      />
                    </div>
                    <div className="">
                      <h6>+0</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-5">
                    <div className="card-boxp">
                      <img
                        className="img-fluid"
                        src="https://onlinebuzzmall.com/assets/images/platform-types/uxiiganpPL1737397501.webp"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="futures-card-items">
                      <h5 className="">Amazon</h5>
                      <div className="row">
                        <div className="d-flex">
                          <div className="futures-commission-amount">
                            <h6>
                              <a href="#">20 USDT-499 USDT</a>
                            </h6>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-0">
                        <div className="d-flex align-items-center futures-commission-area">
                          <div>
                            <p>Commission:</p>
                          </div>
                          <div>
                            <h6>4 %</h6>
                          </div>
                        </div>
                      </div>
                      <div>
                        <a
                          href="#"
                          className="buyBtn btn btn-sm border-custom btn-outline-warning mt-3"
                        >
                          Order Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-5">
                    <div className="card-boxp">
                      <img
                        className="img-fluid"
                        src="https://onlinebuzzmall.com/assets/images/platform-types/XiFsQ1BrLI1737397515.png"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="futures-card-items">
                      <h5 className="">AliBaba</h5>
                      <div className="row">
                        <div className="d-flex ">
                          <div className="futures-commission-amount">
                            <h6>
                              <a href="#">500 USDT-899 USDT</a>
                            </h6>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-0">
                        <div className="d-flex align-items-center futures-commission-area">
                          <div>
                            <p>Commission:</p>
                          </div>
                          <div>
                            <h6>8 %</h6>
                          </div>
                        </div>
                      </div>
                      <div>
                        <a
                          href="#"
                          className="buyBtn btn btn-sm border-custom btn-outline-warning  mt-3"
                        >
                          Order Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-5">
                    <div className="card-boxp">
                      <img
                        className="img-fluid"
                        src="https://onlinebuzzmall.com/assets/images/platform-types/Qqyzm6bcoB1737397536.png"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="futures-card-items">
                      <h5 className="">AliExpress</h5>
                      <div className="row">
                        <div className="d-flex">
                          <div className="futures-commission-amount">
                            <h6>
                              <a href="#">≥900 USDT</a>
                            </h6>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-0">
                        <div className="d-flex align-items-center futures-commission-area">
                          <div>
                            <p>Commission:</p>
                          </div>
                          <div>
                            <h6>12 %</h6>
                          </div>
                        </div>
                      </div>
                      <div>
                        <a
                          href="#"
                          className="buyBtn btn btn-sm border-custom btn-outline-warning  mt-3"
                        >
                          Order Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Futures;
